<template>
  <customs-declaration
    :job="job"
    :is-editing="isEditing"
    :del-po-items-uuids="job.delPoItemsUuids || []"
    @quantityActualChange="onChange('quantityActual')"
    @weightActualChange="onChange('weightActual')"
    @cubageActualChange="onChange('cubageActual')"
  />
</template>

<script>
import customsDeclaration from '@/components/Cargo/Job/customsDeclaration'

export default {
  name: 'SeBasicCustomsDeclaration',
  components: {
    customsDeclaration
  },
  props: {
    job: { type: Object, required: true },
    isEditing: { type: Boolean, required: true }
  },
  watch: {
    job: {
      immediate: true,
      handler(newVal) {
        newVal.delPoItemsUuids = newVal.delPoItemsUuids || []
      }
    }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
